import logoNav from '../assets/img/logo.svg'
import logoLogin from '../assets/img/group559.svg'
import logoDark from '../assets/img/logo_dark.svg'
import logoStage from '../assets/img/logo_stage.svg'

export type DepotoClientType = 'prod' | 'stage' | 'dev' | 'custom'

export type DepotoLogoVariant = 'nav' | 'login' | 'dark'

export const STAGE_SERVER_TOOLTIP = 'Varování - připojeno ke stage serveru'

export function isStageEnvironment(clientType?: string): boolean {
  return clientType === 'stage'
}

export function getDepotoLogoSrc(variant: DepotoLogoVariant, clientType?: string): string {
  if (isStageEnvironment(clientType)) {
    return logoStage
  }

  switch (variant) {
    case 'login':
      return logoLogin
    case 'dark':
      return logoDark
    case 'nav':
    default:
      return logoNav
  }
}
